<template>
  <div class="portfolio">
    <sub-banner>
      <template v-slot:text>
        <h1 class="fw-bold">Foto's</h1>
      </template>
    </sub-banner>
    <div class="container-xxl py-5" style="margin-top: -110px">
      <div class="container">
        <div class="text-center mx-auto mb-5 wow fadeInUp" data-wow-delay="0.1s"
             style="max-width: 500px; visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
          <p class="text-primary text-uppercase mb-2">Klussen</p>
          <h1 class="display-6 mb-0 fw-bold">Impressie van ons werk</h1>
        </div>
        <p class="text-center fs-5 mb-5">Een beeld zegt meer dan duizend woorden. Bekijk hier een selectie van onze
          afgeronde projecten, van installaties tot onderhoud. Bij FTM Installatietechniek staan vakmanschap en
          kwaliteit centraal in alles wat we doen. Laat je inspireren door ons werk!</p>
        <div class="row g-4">
          <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.1s"
               style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="row g-3">
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/binnen.webp">
                </div>
              </div>
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/roof.webp">
                </div>
              </div>

            </div>
          </div>

          <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.5s"
               style="visibility: visible; animation-delay: 0.5s; animation-name: fadeInUp;">
            <div class="row g-3">
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/bus.webp">
                </div>
              </div>
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/airco2.webp">
                </div>
              </div>
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/vloerverwarming.webp">
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s"
               style="visibility: visible; animation-delay: 0.3s; animation-name: fadeInUp;">
            <div class="row g-3">
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/zolder.webp">
                </div>
              </div>
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/tab.webp">
                </div>
              </div>
              <div class="col-12">
                <div class="project-item">
                  <img alt="" class="img-fluid" src="img/zon.webp">
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import SubBanner from "@/components/SubBanner";

export default {
  name: "Portfolio",
  components: {
    SubBanner,
  },
  created() {
    window.scrollTo(0, 0)
  },
  mounted() {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="scss" scoped>

$gold: #D6AD60;
$gold-d2: #9a7836;
$coal: #122620;

.portfolio {

  .portfolio-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    @media (max-width: 900px) {
      display: flex;
      flex-direction: column;
    }
    gap: 45px;
    height: fit-content;
    padding-bottom: 100px;

    .portfolio-item {
      grid-column: span 2;
      display: flex;
      width: 100%;
      background: $gold;
      height: 100px;
      position: relative;
      max-height: 250px;
      min-height: 250px;
      @media (max-width: 900px) {
        min-height: 350px;
        max-height: 350px;
      }

      img {
        width: 100%;
        height: 100% !important;
        object-fit: cover;
      }

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background: linear-gradient(47.13deg, rgba(30, 30, 30, 0.55) 0%, rgba(207, 215, 255, 0) 100%);
        z-index: 1;
      }
    }

    .portfolio-item:nth-child(-n+2), .portfolio-item:nth-child(8n+10), .portfolio-item:nth-child(8n+9) {
      grid-column: span 3;
      max-height: 300px;
      min-height: 300px;
      @media (max-width: 900px) {
        min-height: 350px;
        max-height: 350px;
      }
    }
  }
}
</style>
